import type { TProperty } from 'stores/fieldAssetStore/helperTypes'
import type { TLure } from '../types'

export const getSuggestedLures = (
  lures: TLure[],
  insectId: number | null | undefined,
  property: TProperty | undefined,
): { default?: TLure[]; others: TLure[] } => {
  let suggestedLures: TLure[] = []

  // First, filter lures which apply to the same insects as the selected target insect
  if (insectId) {
    suggestedLures = lures.filter((lure) => lure.insectIds.includes(insectId))
  }

  if (!suggestedLures.some((lure) => lure.defaultLocations?.length)) {
    return { others: suggestedLures }
  }

  // Ignore default lures locations if property isn't loaded yet
  if (!property) return { others: suggestedLures }

  // Second, refine suggestions by selecting the default lure for the property location
  const { isoCountryCode: country, isoStateCode: state } = property

  const defaultLuresInState = suggestedLures.filter((lure) =>
    lure.defaultLocations.includes(`${country}/${state}`),
  )

  const defaultLuresInCountry = suggestedLures.filter((lure) => lure.defaultLocations.includes(country))
  const defaultLuresInAllLocations = suggestedLures.filter((lure) => lure.defaultLocations.includes('ALL'))

  // Return the default lures, if there is one (there can be more than 1 default lure for a location, if it's a combined lure)
  if (defaultLuresInState.length) {
    const otherLures = suggestedLures.filter((lure) => !defaultLuresInState.includes(lure))

    return { default: defaultLuresInState, others: otherLures }
  } else if (defaultLuresInCountry.length) {
    const otherLures = suggestedLures.filter((lure) => !defaultLuresInCountry.includes(lure))

    return { default: defaultLuresInCountry, others: otherLures }
  } else if (defaultLuresInAllLocations.length) {
    const otherLures = suggestedLures.filter((lure) => !defaultLuresInAllLocations.includes(lure))

    return { default: defaultLuresInAllLocations, others: otherLures }
  }

  // Otherwise, return suggested lures based on insect selection
  return { others: suggestedLures }
}
